import * as React from 'react'
import { NavigationContainer } from '@react-navigation/native'
import { createStackNavigator } from '@react-navigation/stack'
import { AuthStack, AuthStackScreenNames } from './AuthStack'
import { navigationRef } from './coordinator/navigationService'
import { NavigationScreenProp } from 'react-navigation'
import { MainStack, MainStackScreenNames } from './MainStack'

export interface BaseNavigationProps {
  navigation: NavigationScreenProp<any, any>
}

const Stack = createStackNavigator()

const AuthStackScreens = AuthStack(Stack)
const MainStackScreens = MainStack(Stack)

export const RootNavigation: React.FC<{ isLogged: boolean }> = ({ isLogged }) => {
  // debugger
  return (
    <NavigationContainer ref={navigationRef} documentTitle={{ enabled: true, formatter: () => 'Lar brio' }}>
      <Stack.Navigator initialRouteName={isLogged ? MainStackScreenNames.Dashboard : AuthStackScreenNames.Login}>
        {AuthStackScreens}
        {MainStackScreens}
      </Stack.Navigator>
    </NavigationContainer>
  )
}
